export default __webpack_public_path__ + "static/char-v-35-zh-Hant-10ce531538135c8dbc664c9977debad2.mp4";